/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChart = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M20 20V7.4l1.7-1.7-1.4-1.4-8.8 8.8L8 9.6l-4 4V2H2v20h20v-2h-2zM4 20v-3.6l2-2V20H4zm4 0v-7.6l2 2V20H8zm4 0v-4.6l2-2V20h-2zm4 0v-8.6l2-2V20h-2z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgChart as Chart };
